import {Controller} from "stimulus"
import AutoNumeric from "autonumeric"

export var DEBOUNCE_DELAY = 400;

export function collectInputValues(container) {
    var inputFields = container.querySelectorAll('.misc-charge-dynamic-fields input');
    var inputValues = {};
    inputFields.forEach(function(field) {
        var name = field.name.match(/\[input_values\]\[(\w+)\]/);
        if (name) inputValues[name[1]] = field.value;
    });
    return inputValues;
}

export function allChargesReady() {
    var allPostFieldValues = Array.prototype.map.call(
        document.querySelectorAll(".post-ready"),
        function(element) { return element.value; }
    );
    var allReady = allPostFieldValues.every(function(v) { return v.length > 0; });
    if (allReady) {
        var flashArea = document.querySelector('#flash-area');
        if (flashArea) flashArea.innerHTML = "";
    }
    document.querySelectorAll(".charge-checkout-button").forEach(function(btn) {
        btn.disabled = !allReady;
    });
    return allReady;
}

export default class extends Controller {

    static targets = [
        "inputFields", "amountField",
        "entitySearch", "entityResults", "entitySelected", "entitySelectedName", "entitySelectedType",
        "linkedEntityId", "linkedEntityType"
    ]

    connect() {
        var amountEl = this.element.querySelector(".cr-adj-amount");
        if (amountEl) {
            this.chargeField = new AutoNumeric(
                amountEl,
                ['NorthAmerican', {unformatOnSubmit: true}]
            );
        }

        // Render input fields if a charge type is already selected on page load
        var select = this.element.querySelector("#cr_misc_charge_cr_charge_type_id");
        if (select && select.value) {
            this._renderInputFields(select);
        }
    }

    addCharge(e) {
    }

    addToCart(e) {
    }

    chargeTypeChanged(e) {
        // Clear amount and reset readiness when switching charge type
        if (this.chargeField) {
            this.chargeField.set('');
        } else {
            this.amountFieldTarget.value = '';
        }
        this.amountFieldTarget.readOnly = false;
        this.amountFieldTarget.classList.remove('bg-gray-100');
        this._renderInputFields(e.target);
        this._updatePostReady();
    }

    _renderInputFields(select) {
        var chargeTypeId = select.value;
        var inputFieldsData = JSON.parse(select.dataset.crMiscChargesInputFieldsValue || '{}');

        var inputFieldsContainer = this.inputFieldsTarget;
        var existingValues = JSON.parse(inputFieldsContainer.dataset.crMiscChargesExistingInputValues || '{}');
        inputFieldsContainer.innerHTML = '';

        if (chargeTypeId && inputFieldsData[chargeTypeId] && inputFieldsData[chargeTypeId].length > 0) {
            var fields = inputFieldsData[chargeTypeId];
            var wrapper = document.createElement('div');
            wrapper.className = 'misc-charge-dynamic-fields grid grid-cols-1 md:grid-cols-2 gap-4';
            var controller = this;

            fields.forEach(function(field) {
                var fieldType = field.field_type === 'number' ? 'number' : 'text';

                var fieldDiv = document.createElement('div');

                var label = document.createElement('label');
                label.setAttribute('for', 'cr_misc_charge_input_values_' + field.name);
                label.className = 'block text-gray-500 mb-2';
                label.textContent = field.label;
                fieldDiv.appendChild(label);

                var input = document.createElement('input');
                input.type = fieldType;
                input.name = 'cr_misc_charge[input_values][' + field.name + ']';
                input.id = 'cr_misc_charge_input_values_' + field.name;
                input.className = 'm-0 text-[16px] p-3 w-full rounded-xl border-2 border-gray-300 focus-visible:border-purple-300 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-purple-600 shadow-inner shadow-gray-100 placeholder-gray-300';
                input.step = 'any';
                if (field.name in existingValues) {
                    input.value = existingValues[field.name];
                }
                // Bind directly — Stimulus 1.1 MutationObserver may not
                // pick up data-action on dynamically created elements.
                input.addEventListener('input', function() {
                    clearTimeout(controller._recalcTimer);
                    controller._recalcTimer = setTimeout(function() {
                        controller._doRecalculate();
                    }, DEBOUNCE_DELAY);
                });
                fieldDiv.appendChild(input);

                wrapper.appendChild(fieldDiv);
            });

            inputFieldsContainer.appendChild(wrapper);
            inputFieldsContainer.style.display = '';
            // Clear existing values after first render so charge type
            // changes don't carry over stale data
            inputFieldsContainer.dataset.crMiscChargesExistingInputValues = '{}';

            // Don't lock amount field yet — it will be locked after a
            // successful server-side calculation in _doRecalculate().
            this.amountFieldTarget.readOnly = false;
            this.amountFieldTarget.classList.remove('bg-gray-100');
        } else {
            inputFieldsContainer.style.display = 'none';
            this.amountFieldTarget.readOnly = false;
            this.amountFieldTarget.classList.remove('bg-gray-100');
        }
    }

    _doRecalculate() {
        var formArea = this.element;
        var selectEl = formArea.querySelector("#cr_misc_charge_cr_charge_type_id");
        var chargeTypeId = selectEl.value;
        if (!chargeTypeId) return;

        // Only call calculate when the charge type has configured calculators.
        // Charge types with input fields but no calculators use inputs for
        // informational capture — the user enters the amount manually.
        var calculableIds = JSON.parse(selectEl.dataset.crMiscChargesCalculableValue || '[]');
        if (calculableIds.indexOf(parseInt(chargeTypeId)) === -1) {
            this._updatePostReady();
            return;
        }

        var inputValues = collectInputValues(formArea);

        var csrfMeta = document.querySelector('meta[name="csrf-token"]');
        var amountField = this.amountFieldTarget;
        var chargeField = this.chargeField;
        var controller = this;

        fetch('/cr_misc_charges/calculate', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-Token': csrfMeta ? csrfMeta.content : ''
            },
            body: JSON.stringify({cr_charge_type_id: chargeTypeId, input_values: inputValues})
        })
        .then(function(response) {
            if (!response.ok) {
                if (chargeField) {
                    chargeField.set('');
                } else {
                    amountField.value = '';
                }
                amountField.readOnly = false;
                amountField.classList.remove('bg-gray-100');
                controller._updatePostReady();
                return null;
            }
            return response.json();
        })
        .then(function(data) {
            if (!data) return;
            var amt = parseFloat(data.amount);
            if (!isNaN(amt) && amt > 0) {
                if (chargeField) {
                    chargeField.set(data.amount);
                } else {
                    amountField.value = data.amount;
                }
                amountField.readOnly = true;
                amountField.classList.add('bg-gray-100');
            } else {
                if (chargeField) {
                    chargeField.set('');
                } else {
                    amountField.value = '';
                }
                amountField.readOnly = false;
                amountField.classList.remove('bg-gray-100');
            }
            controller._updatePostReady();
        })
        .catch(function() {
            if (chargeField) {
                chargeField.set('');
            } else {
                amountField.value = '';
            }
            amountField.readOnly = false;
            amountField.classList.remove('bg-gray-100');
            controller._updatePostReady();
        });
    }

    recalculate(e) {
        var controller = this;
        clearTimeout(controller._recalcTimer);
        controller._recalcTimer = setTimeout(function() {
            controller._doRecalculate();
        }, DEBOUNCE_DELAY);
    }

    _updatePostReady() {
        var formArea = this.element;
        var miscTypePresent = formArea.querySelector("#cr_misc_charge_cr_charge_type_id").value;
        var amountEl = formArea.querySelector("#cr_misc_charge_amount");
        var miscAmountValue = this.chargeField ? AutoNumeric.getNumber(amountEl) : parseFloat(amountEl.value);
        var miscAmountPresent = miscAmountValue > 0;
        var miscMemoPresent = formArea.querySelector("#cr_misc_charge_description").value;

        // Memo is optional when input fields are present and filled in
        var inputFieldsFilled = this._inputFieldsFilled();
        var descriptionOk = miscMemoPresent || inputFieldsFilled;

        var miscPostReadyField = formArea.querySelector(".post-ready");
        if (miscPostReadyField) {
            miscPostReadyField.value = (descriptionOk && miscAmountPresent && miscTypePresent) ? "true" : "";
        }
        allChargesReady();
    }

    _inputFieldsFilled() {
        var container = this.inputFieldsTarget;
        var inputs = container.querySelectorAll('.misc-charge-dynamic-fields input');
        if (inputs.length === 0) return false;
        return Array.prototype.every.call(inputs, function(field) {
            return field.value.trim().length > 0;
        });
    }

    searchEntity(e) {
        if (e.key === 'Enter') { e.preventDefault(); return; }
        if (e.key === 'Escape') {
            this.entityResultsTarget.classList.add('hidden');
            return;
        }

        clearTimeout(this.searchTimeout);
        const query = this.entitySearchTarget.value.trim();

        if (query.length < 3) {
            this.entityResultsTarget.classList.add('hidden');
            return;
        }

        this.searchTimeout = setTimeout(() => {
            fetch('/search/query.json?search=' + encodeURIComponent(query) + '&polymorphic=Business,Contact&limit=5')
                .then(response => response.json())
                .then(results => this.renderEntityResults(results))
                .catch(error => console.error('Entity search error:', error));
        }, 300);
    }

    renderEntityResults(results) {
        const typeMap = {businesses: 'Business', contacts: 'Contact'};
        const allowedTypes = Object.keys(typeMap);
        const container = this.entityResultsTarget;
        container.innerHTML = '';

        let hasResults = false;
        allowedTypes.forEach(type => {
            const items = results[type];
            if (items && items.length > 0) {
                hasResults = true;

                const header = document.createElement('div');
                header.className = 'px-4 py-1 text-xs font-semibold text-gray-400 uppercase tracking-wider border-b border-gray-100';
                header.textContent = typeMap[type] || type;
                container.appendChild(header);

                items.forEach(item => {
                    const btn = document.createElement('button');
                    btn.type = 'button';
                    btn.className = 'block w-full text-left !text-black bg-purple-200 px-4 py-2 hover:bg-purple-700 cursor-pointer text-sm !p-2 !m-0 !rounded-none';
                    btn.textContent = this.entityDisplayName(type, item);
                    btn.dataset.entityId = item.id;
                    btn.dataset.entityType = typeMap[type] || type;
                    // Bind directly — Stimulus 1.1 MutationObserver may not
                    // pick up data-action on dynamically created elements.
                    btn.addEventListener('click', (e) => {
                        this.selectEntity(e);
                    });
                    container.appendChild(btn);
                });
            }
        });

        if (!hasResults) {
            container.innerHTML = '<div class="px-4 py-2 text-sm text-gray-400">No results found</div>';
        }

        container.classList.remove('hidden');
    }

    entityDisplayName(type, item) {
        if (type === 'businesses') return item.business_name || '';
        if (type === 'contacts') return item.name_search_string || '';
        return item.name || String(item.id);
    }

    selectEntity(e) {
        const el = e.currentTarget;
        const id = el.dataset.entityId;
        const type = el.dataset.entityType;

        this.linkedEntityIdTarget.value = id;
        this.linkedEntityTypeTarget.value = type;

        this.entitySearchTarget.value = '';
        this.entityResultsTarget.classList.add('hidden');

        this.entitySelectedTarget.classList.remove('hidden');
        this.entitySelectedNameTarget.textContent = el.textContent.trim();
        this.entitySelectedTypeTarget.textContent = '(' + type + ')';
    }

    clearEntity(e) {
        e.preventDefault();
        this.linkedEntityIdTarget.value = '';
        this.linkedEntityTypeTarget.value = '';
        this.entitySearchTarget.value = '';
        this.entityResultsTarget.classList.add('hidden');
        this.entitySelectedTarget.classList.add('hidden');
        this.entitySelectedNameTarget.textContent = '';
        this.entitySelectedTypeTarget.textContent = '';
    }

    setFieldSetPostable(e) {
        this._updatePostReady();
    }

    deleteCharge(e) {
        e.preventDefault();
        var fieldset = e.target.closest('.misc-charge-fieldset');
        if (fieldset) {
            fieldset.remove();
            allChargesReady();
        }
    }

}
